import { convertKeyToEnvName } from './convertKeyToEnvName';

/**
 * Get a value from the environment (without validation)
 */
export function getValueFromEnv(...args: Parameters<typeof convertKeyToEnvName>): string | undefined {
  const name = convertKeyToEnvName(...args);
  return process.env[String(name)];
}
